import { css } from '@emotion/css';

export const popoverStyles = css`
  width: 30.8rem;
  height: 44.4rem;
`;

export const removePadding = css`
  padding: 0 !important;
`;

export const overlay = css`
  min-width: 24px;
  .overlay {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.44);
    border-radius: 100%;
    opacity: 0;
  }
  &:hover .overlay {
    opacity: 1;
  }
`;
